"use client";

import type React from "react";

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Input,
  VStack,
  Text,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";
import { useState, useEffect } from "react";

interface FilenameDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (filename: string) => void;
  defaultFilename: string;
  title?: string;
}

export default function FilenameDialog({
  isOpen,
  onClose,
  onConfirm,
  defaultFilename,
  title = "Download File",
}: FilenameDialogProps) {
  const [filename, setFilename] = useState(defaultFilename);

  useEffect(() => {
    setFilename(defaultFilename);
  }, [defaultFilename]);

  const handleConfirm = () => {
    if (filename.trim()) {
      onConfirm(filename.trim());
      onClose();
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      handleConfirm();
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4} align="stretch">
            <Text color="gray.600">
              Choose a name for your downloaded file:
            </Text>
            <FormControl>
              <FormLabel>Filename</FormLabel>
              <Input
                value={filename}
                onChange={(e) => setFilename(e.target.value)}
                onKeyPress={handleKeyPress}
                placeholder="Enter filename..."
                autoFocus
                bg="gray.50"
              />
            </FormControl>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="ghost"
            colorScheme="gray"
            color={"gray.600"}
            _hover={{ bg: "gray.100" }}
            mr={3}
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            colorScheme="primary"
            onClick={handleConfirm}
            isDisabled={!filename.trim()}
          >
            Download
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
